<template>
  <b-overlay :show="isLoading">
    <SelectComponent
        :options="components | idNameToValueLabel"
        :disabled="disabled"
        :searching="isLoading"
        @search="autocomplete"
        @input="evt => $emit('input', evt)"
        v-model="local_model">
      <template v-slot:no-results>
        {{ $t('components.select.nenhum_resultado') }}:<br/>
        "{{ stringSearch }}"<br/>
        {{ $t('components.select.deseja_incluir') }}<br/>
        <b-button variant="success" size="sm" class="ml-2" pill @click="addNew">
          {{ $t('components.select.sim') }}
        </b-button>
      </template>
    </SelectComponent>
  </b-overlay>
</template>

<script>
import SelectComponent from "@/components/SelectComponent";
import ComponentRepository from '@/repositories/tuevs/ComponentRepository';
import {mapActions, mapGetters} from "vuex";

export default {
  name: "SelectTuevsComponent",
  components: {SelectComponent},
  props: {
    model: null,
    disabled: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapGetters({
      isLoading: 'tuevs/component/isLoading',
      components: 'tuevs/component/all',
    })
  },
  data() {
    return {
      stringSearch: '',
      local_model: null,
      awaitingSearch: false
    }
  },
  methods: {
    ...mapActions([
      'tuevs/component/search',
    ]),
    async autocomplete(string) {
      this.stringSearch = string
      if (string.length >= 3 && !this.awaitingSearch) {
        setTimeout(() => {
          // TODO: REMOVER E PASSAR CASE SENSITIVE PARA P BANCO
          this.temporallyStringPrepareToSQL('name', string).map(async array => {
            await this['tuevs/component/search']({filters: [array]})
          })
          this.awaitingSearch = false
        }, 1000)
        this.awaitingSearch = true
      }
    },
    // TODO: REMOVER E PASSAR CASE SENSITIVE PARA P BANCO
    temporallyStringPrepareToSQL(field, valueTyped) {
      const string = valueTyped.toLowerCase()
      return [
        [field, 'LIKE', '%' + valueTyped + '%'],
        [field, 'LIKE', '%' + string + '%'],
        [field, 'LIKE', '%' + string.toUpperCase() + '%'],
        [field, 'LIKE', '%' + string.charAt(0).toUpperCase() + string.slice(1) + '%'],
      ]
    },
    async addNew() {
      ComponentRepository.post({
        code: this.stringSearch,
        name: this.stringSearch,
        status: 1
      }).then(response => {
        this.$snotify.success(this.$t('tuevs.component.form.create.success'))
        this.autocomplete(this.stringSearch)
      }).catch(error => {
        this.$snotify.error(this.$t('tuevs.component.form.create.error'))
      })
    },
  },
  mounted() {
    this['tuevs/component/search']()
    this.local_model = this.model
  },
  beforeUpdate() {
    this.local_model = this.model
  }
}
</script>

<style lang="scss" scoped>
</style>